import React from "react";
import { Accordion, MessageBanner } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
import { useTitleMerges } from "../../../hooks/useTitleMerges";
import { formatDateTime } from "../../../utils/formatUtils";
import { TitleSourceBadge } from "./TitleSourceBadge";
import css from "./MergeDuplicateTitles.module.css";
export var MergedRecordsSection = function (_a) {
    var titleId = _a.titleId;
    var _b = useTitleMerges(titleId), merges = _b.merges, isMergesError = _b.isMergesError;
    if (isMergesError) {
        return (React.createElement(Accordion, { id: "merged-records", label: React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.titleMerge.merged.headingPlain" }) },
            React.createElement(MessageBanner, { type: "error", "data-test-id": "merged-records-failed" },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.titleMerge.merged.failed" }))));
    }
    if (merges.length === 0)
        return null;
    return (React.createElement(Accordion, { id: "merged-records", label: React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.titleMerge.merged.heading", values: { count: merges.length } }) },
        React.createElement("table", { className: css.mergedTable, "data-test-id": "merged-records-section" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { scope: "col" },
                        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.titleMerge.merged.column.record" })),
                    React.createElement("th", { scope: "col" },
                        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.titleMerge.merged.column.source" })),
                    React.createElement("th", { scope: "col" },
                        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.titleMerge.merged.column.identifiers" })),
                    React.createElement("th", { scope: "col" },
                        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.titleMerge.merged.column.when" })))),
            React.createElement("tbody", null, merges.map(function (merge) {
                var _a, _b;
                return (React.createElement("tr", { key: merge.id },
                    React.createElement("td", null, merge.loserTitleName),
                    React.createElement("td", null,
                        React.createElement(TitleSourceBadge, { source: merge.loserSource, provisional: merge.loserProvisional })),
                    React.createElement("td", null, ((_a = merge.identifiers) !== null && _a !== void 0 ? _a : []).length > 0 ? (((_b = merge.identifiers) !== null && _b !== void 0 ? _b : []).join(" · ")) : (React.createElement("span", { className: css.empty },
                        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.titleMerge.merged.noIdentifiers" })))),
                    React.createElement("td", null, "".concat(formatDateTime(merge.mergedAt), " \u00B7 ").concat(merge.actorDisplayName))));
            }))),
        React.createElement("p", { className: css.hint },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.titleMerge.merged.note" }))));
};
